var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mosaic",style:(_vm.mosaicGridStyle)},_vm._l((_vm.pieces),function(n){return _c('MosaicPiece',{key:n,attrs:{"state":_vm.piecesStates[n],"records":_vm.records}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }